<template>
  <!-- <img alt="Vue logo" src="./assets/logo.png"> -->
  <router-view />
  <!-- <router-link to="/home">home</router-link>
  <router-link to="/set" style="marginLeft:20px">set</router-link> -->
</template>

<script>

export default {
  name: 'App',
}
</script>

<style lang="scss">
@import './assets/css/public.scss';
// $font-color-main:#386AEA;
$button-color-hover:red;


#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-family: -apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,sans-serif;
  color: #000;
  background: #111111;
  min-height: 100vh;
}
div{
  /* word-wrap: break-word; */
  word-break: break-all;
}
.font-bold {
  font-weight: bold;
}

#nprogress .bar {
  background: #386aea !important;
}
</style>
